import React from "react";
import { Routes, Route } from "react-router-dom";
import { Main } from "../pages/main/Main";
import { BlogStudioPage } from "../pages/BlogStudio/BlogStudioPage";

export const IndexRoutes = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="/blog" element={<BlogStudioPage />} />
      <Route path="*" element={<Main />} />
    </Routes>
  );
};
